import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  gamContent: {
    marginTop: 40
  }
})

export default useStyles
